import React from 'react';
import { Redirect  } from "react-router-dom";



class ModalCancelOrderFailure extends React.Component {

    state = {
        redirect: null,
        IsCouplingRooms:false,
        HasConnectionDoor:false
    }

    componentDidMount() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
            });

            console.log('ModalOrder componentDidMount props: ', this.props);     
    }

    contextTest = () => {
        console.log('contextTest');       
    } 






    backHomePage = () => {
        this.setState({ redirect: "/" }); 
    }


    setModalOrderConfirmationClosed = () =>  {
        this.setState({ redirect: "/" }); 
    }
    

  render() {

    
    if (this.state.redirect) {        
        return <Redirect to={this.state.redirect} />
    } 
    
    return (

            <div className="cntered-flex">
                <React.Fragment >      
                <div className="modal_main_bg2" ></div>
                    <div className="cntered-flex">
                        <div className="modal_order_confirmation_bg">

                            <div className="close_arrow pointer zindex1000" onClick={this.setModalOrderConfirmationClosed}></div>

                            <div className="modal_order_inner_bg">
                              
                                <div className="modal_order_top">                            
                                    <div className="modal_order_title1"> ביטול
                                    ההזמנה נכשל</div>
                                </div>
                                

                                <div className="modal_order_title_hotel directionRtl">
                                    קיימת תקלה זמנית בשירות,
                                    נסה במועד מאוחר יותר.
                                </div>

                                <div className="modal_order_title_hotel directionRtl">
                                    פנה למנהל המערכת.
                                </div>
                                   

                                <div className="modal_order_confirmation_container">
                                    <div className="cntered-flex marginTop20">
                                        <div className="hp_search_main_button"
                                                onClick={() => this.backHomePage()}>
                                            <span className="hp_search_main_button_title">
                                            חזרה לדף הראשי
                                            </span>
                                        </div>
                                    </div>
                                            
                                </div>

                            </div>

                        </div>
                    </div>                
                </React.Fragment>
            </div>
    );
  }
}


export default ModalCancelOrderFailure;
